module.exports = __webpack_public_path__ + "static/media/11NEPAD5.df2b00de.jpg";